'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  margin: auto;\n  background: ', ';\n  box-shadow: rgba(0, 0, 0, 0.0980392) 0px 0px 20px 0px;\n\n  ', '\n'], ['\n  box-sizing: border-box;\n  margin: auto;\n  background: ', ';\n  box-shadow: rgba(0, 0, 0, 0.0980392) 0px 0px 20px 0px;\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n          width: 100%;\n          max-width: 21cm;\n          padding: 1in;\n          ', '\n        '], ['\n          width: 100%;\n          max-width: 21cm;\n          padding: 1in;\n          ', '\n        ']),
    _templateObject3 = _taggedTemplateLiteral(['\n            padding: 20px;\n          '], ['\n            padding: 20px;\n          ']),
    _templateObject4 = _taggedTemplateLiteral(['\n          width: 21cm;\n          padding: 1in;\n        '], ['\n          width: 21cm;\n          padding: 1in;\n        ']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../libs/colors');

var _media = require('../../../libs/media');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors


var Content = _styledComponents2.default.div(_templateObject, _colors.white, function (_ref) {
  var dynamic = _ref.dynamic;
  return dynamic ? (0, _styledComponents.css)(_templateObject2, _media.media.s(_templateObject3)) : (0, _styledComponents.css)(_templateObject4);
});

exports.default = Content;